import React from 'react';
import ReactApexChart from "react-apexcharts";
import * as moment from "moment";

function Range_Bar_Chart({ width, height, data }) {
  try {
    if (!data || typeof data !== 'object' || !data.series) {
      throw new Error("Invalid chart data");
    }

    const restoredData = restoreFunctions(data);

    return (
      <ReactApexChart
        dir="ltr"
        className="apex-charts"
        options={restoredData}
        series={restoredData.series}
        type="rangeBar"
        height={height}
        width={width}
      />
    );
  } catch (error) {
    console.error("Range Bar Chart error:", error);
    return (
      <div style={{ color: "red", padding: "10px" }}>
       Something went wrong. Use Another favorite prompt to generate
      </div>
    );
  }
}

export default Range_Bar_Chart;

function restoreFunctions(config) {
  function safelyParseFunction(funcStr) {
    try {
      if (typeof funcStr === 'string' && funcStr.trim().startsWith("function(")) {
        const argsStart = funcStr.indexOf('(') + 1;
        const argsEnd = funcStr.indexOf(')');
        const args = funcStr.slice(argsStart, argsEnd).trim();
        const body = funcStr.slice(funcStr.indexOf('{') + 1, funcStr.lastIndexOf('}')).trim();
        return new Function(args, body);
      }
    } catch (e) {
      console.warn("Failed to parse formatter function:", e);
    }
    return null;
  }

  if (config.dataLabels && typeof config.dataLabels.formatter === "string") {
    const parsedFn = safelyParseFunction(config.dataLabels.formatter);
    if (parsedFn) {
      config.dataLabels.formatter = parsedFn;
    }
  }

  return config;
}
